<template>
    <div class="container">
        <!-- <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item> <i class="iconfont icon-qiye"></i> 企业管理 </el-breadcrumb-item>
            </el-breadcrumb>
        </div> -->
        <div class="">
            <div class="handle-box" style="padding-left: 10px">
                <!-- <el-button
                    type="primary"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
                >批量删除</el-button> -->
                <el-button type="primary" icon="el-icon-circle-plus-outline" class="handle-del mr10"
                    @click="addCompany">增加企业</el-button>
                <!-- <el-select v-model="query.address" placeholder="地址" class="handle-select mr10">
                    <el-option key="1" label="广东省" value="广东省"></el-option>
                    <el-option key="2" label="湖南省" value="湖南省"></el-option>
                </el-select> -->
                <el-input v-model="query.searchValue" placeholder="请输入企业名称" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button type="primary" icon="el-icon-refresh-right" @click="handleResetSearch">重置</el-button>
            </div>

            <mscard class="projcetCard">
                <template v-slot:header>
                    <div class="cardTitle">企业列表</div>
                    <!-- <div class="cardTitle">企业列表 - {{ deviceListData[0].projectId }}</div> -->
                </template>
                <template v-slot:body>
                    <table class="projectStyle" cellspacing="0">
                        <tr class="projectHeader" style="text-align: center">
                            <th>企业名称</th>
                            <th>企业角色</th>
                            <th>注册时间</th>
                            <th>更新时间</th>
                            <th>操作</th>
                        </tr>
                        <tr v-for="(item, index) in tableData" :key="index"
                            :class="selectDevice == index ? 'projectBody selcetBgc' : 'projectBody'"
                            style="text-align: center">
                            <td>{{ item.name }}</td>
                            <td>{{ item.role === '0' ? '圣豆电子' : '普通企业' }}</td>
                            <td>{{ item.createtime }}</td>
                            <td>{{ item.updatetime }}</td>
                            <td class="moreDeviceDetail">
                                <el-button type="text" @click="queryUser(index, item)">查看用户</el-button>
                                <el-button type="text" @click="bindUser(index, item)">绑定用户</el-button>
                                <el-button type="text" @click="queryProject(index, item)">查看项目</el-button>
                                <el-button type="text" @click="bindProject(index, item)">绑定项目</el-button>
                                <el-button type="text" class="red" @click="handleDelete(index, item)">删除</el-button>
                            </td>
                        </tr>
                    </table>
                </template>
            </mscard>

            <!-- <el-table
                :data="tableData"
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column prop="name" align="center" label="企业名称"></el-table-column>
                <el-table-column label="企业角色" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.role === '0' ? 'success' : ''">
                            {{ scope.row.role === '0' ? '圣豆电子' : '普通企业' }}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="createtime" align="center" label="注册时间"></el-table-column>
                <el-table-column prop="updatetime" align="center" label="更新时间"></el-table-column>
                <el-table-column label="操作" width="320" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="queryUser(scope.$index, scope.row)">查看用户</el-button>
                        <el-button type="text" @click="bindUser(scope.$index, scope.row)">绑定用户</el-button>
                        <el-button type="text" @click="queryProject(scope.$index, scope.row)">查看项目</el-button>
                        <el-button type="text" @click="bindProject(scope.$index, scope.row)">绑定项目</el-button>
                        <el-button type="text" class="red" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table> -->
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex"
                    :page-size="query.pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>

        <!-- 查看用户弹出框 -->
        <el-dialog title="查看用户" :visible.sync="userVisible" width="50%" :before-close="handleYetBindUserDialogClose">
            <el-table :data="userTableData" style="width: 100%">
                <el-table-column prop="name" label="姓名" width="180"></el-table-column>
                <el-table-column prop="phone" label="手机号" width="180"></el-table-column>
                <el-table-column prop="bindDate" label="绑定时间"></el-table-column>
                <el-table-column prop="userCreateDate" label="用户创建时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click="removeUserBindCompany(scope.$index, scope.row)" type="text" size="small"
                            class="red">解绑</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="yetBindUserQuery.pageIndex"
                    :page-size="yetBindUserQuery.pageSize" :total="yetVindUserPageTotal"
                    @current-change="handleYetBindUserPageChange"></el-pagination>
            </div>
        </el-dialog>
        <!-- 查看项目弹出框 -->
        <el-dialog title="查看项目" :visible.sync="projectVisible" width="50%"
            :before-close="handleYetBindProjectDialogClose">
            <el-table :data="projectTableData" style="width: 100%">
                <el-table-column prop="projectId" label="项目ID" width="180"></el-table-column>
                <el-table-column prop="name" label="项目名称"></el-table-column>
                <el-table-column prop="bindDate" label="绑定时间" width="180"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click="removeProjectBindCompany(scope.$index, scope.row)" type="text" size="small"
                            class="red">解绑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next"
                    :current-page="yetBindProjectQuery.pageIndex" :page-size="yetBindProjectQuery.pageSize"
                    :total="yetVindProjectPageTotal" @current-change="handleYetBindProjectPageChange"></el-pagination>
            </div>
        </el-dialog>

        <!-- 绑定用户弹出框 -->
        <el-dialog title="绑定用户" :visible.sync="bindUserVisible" width="50%" :before-close="handleBindUserDialogClose">
            <div class="userSearchBox">
                <el-select v-model="userQueryBox.label" class="handle-select mr10">
                    <el-option key="1" label="姓名" value="姓名"></el-option>
                    <el-option key="2" label="手机号" value="手机号"></el-option>
                </el-select>
                <el-input v-model="userQueryBox.value" placeholder="请输入搜索内容" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleUserSearch">搜索</el-button>
                <el-button type="primary" icon="el-icon-search" @click="handleUserSearchReset">重置</el-button>
            </div>

            <el-table :data="bindUserTableData" style="width: 100%">
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="phone" label="手机号"></el-table-column>
                <el-table-column prop="createDate" label="创建时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click="handleUserBindCompany(scope.$index, scope.row)" type="text"
                            size="small">绑定</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="userPaginationShow">
                <el-pagination background layout="total, prev, pager, next" :current-page="bindUserQuery.pageIndex"
                    :page-size="bindUserQuery.pageSize" :total="bindUserPageTotal"
                    @current-change="handleBindUserPageChange"></el-pagination>
            </div>
        </el-dialog>

        <!-- 绑定项目弹出框 -->
        <el-dialog title="绑定项目" :visible.sync="bindProjectVisible" width="50%"
            :before-close="handleBindProjectDialogClose">
            <el-table :data="bindProjectTableData" style="width: 100%">
                <el-table-column prop="projectId" label="项目ID"></el-table-column>
                <el-table-column prop="projectName" label="项目名称"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click="handleProjectBindCompany(scope.$index, scope.row)" type="text"
                            size="small">绑定</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="bindProjectQuery.pageIndex"
                    :page-size="bindProjectQuery.pageSize" :total="bindProjectPageTotal"
                    @current-change="handleBindUserPageChange"></el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    AllCompany,
    AddCompany,
    QueryUserCompany,
    QueryCompanyUser,
    QueryUser,
    QueryCompanyProject,
    QueryProjectName,
    DeleteCompany,
    QueryUnbindUser,
    CompanyUser,
    CompanyProject,
    QueryUnbindProject,
    CancelUserBindCompany,
    SearchUnCompanyBindUser,
    QueryCompany,
    RemoveProjectBindCompany
} from '../../api/index';
import moment from 'moment';
import mscard from '@/components/common/dashBoard/msCard.vue';
export default {
    name: 'basetable',
    data() {
        return {
            // 绑定用户弹窗搜索分页器显示
            userPaginationShow: true,
            // 绑定用户弹窗搜索
            userQueryBox: {
                label: '姓名',
                value: ''
            },

            // 当前点击的企业id
            clickCompanyId: '',
            yetBindProjectQuery: { pageIndex: 1, pageSize: 10 },
            yetVindProjectPageTotal: 0,
            yetBindUserQuery: {
                pageIndex: 1,
                pageSize: 10
            },
            yetVindUserPageTotal: 0,

            // 绑定项目查询表格弹窗分页
            bindProjectQuery: {
                pageIndex: 1,
                pageSize: 10
            },
            // 绑定项目查询表格弹窗分页总数
            bindProjectPageTotal: 0,
            // 查询未绑定项目的企业id
            queryBindProjectId: '',
            // 绑定项目弹窗显示
            bindProjectVisible: false,
            // 未绑定项目表格信息
            bindProjectTableData: [],

            // 查询未绑定用户得企业id
            queryBindUserId: '',
            // 绑定用户查询表格弹窗分页
            bindUserQuery: {
                pageIndex: 1,
                pageSize: 10
            },
            // 绑定用户查询表格弹窗分页总数
            bindUserPageTotal: 0,
            // 绑定用户弹窗显示
            bindUserVisible: false,
            // 未绑定用户表格信息
            bindUserTableData: [],
            // 查看用户弹窗展示
            userVisible: false,
            // 用户信息
            userTableData: [],
            // 查看项目弹窗展示
            projectVisible: false,
            // 项目信息
            projectTableData: [],
            query: {
                searchTag: 'name',
                searchValue: '',
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1
        };
    },
    created() {
        this.getData();
    },
    methods: {
        // 解绑项目与企业
        async removeProjectBindCompany(index, row) {
            this.$confirm('此操作将会对企业与项目进行解绑, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const result = await RemoveProjectBindCompany({ companyId: this.clickCompanyId, projectId: row.projectId });
                    if (result.code !== 200) {
                        return;
                    }
                    this.$message.success('解绑成功');
                    this.queryProjectData();
                })
                .catch(() => { });
        },
        // 重置搜索条件
        handleUserSearchReset() {
            this.userPaginationShow = true;
            this.userQueryBox = {
                label: '姓名',
                value: ''
            };
            (this.bindUserQuery = {
                pageIndex: 1,
                pageSize: 10
            }),
                this.queryBindUser();
        },
        // 绑定用户时搜索未绑定该企业用户
        async handleUserSearch() {
            // 判断搜索条件是否正常
            let { label, value } = this.userQueryBox;
            label = label.trim();
            value = value.trim();

            let searchTag = '';
            switch (label) {
                case '姓名':
                    searchTag = 'name';
                    break;
                case '手机号':
                    searchTag = 'phone';
                    break;
                default:
                    searchTag = 'null';
                    break;
            }

            if (searchTag == 0 || value == '') {
                this.$message.warning('搜索内容不完整');
                return;
            }

            // 开始进行搜索
            let result = await SearchUnCompanyBindUser({ companyId: this.queryBindUserId, searchTag, value });
            console.log(result);
            if (result.code !== 200) {
                return;
            }
            // 隐藏分页查询器
            this.userPaginationShow = false;
            this.bindUserTableData = result.data;
            this.bindUserTableData.forEach((item, index) => {
                this.bindUserTableData[index].createDate = moment(item.createTime * 1).format('YYYY-MM-DD HH:mm:ss');
            });
            console.log('请求成功');
            console.log(result);
        },
        // 取消用户企业绑定
        async removeUserBindCompany(index, row) {
            // 二次解绑确认
            this.$confirm('确认解绑该用户吗?', '提示', {
                type: 'warning'
            })
                .then(async () => {
                    console.log(row);
                    let result = await CancelUserBindCompany({ companyId: this.clickCompanyId, userId: row.userId });
                    if (result.code !== 200) {
                        return;
                    }
                    this.$message.success('解绑成功');
                    this.queryUserData();
                })
                .catch(() => { });
        },

        // 查看项目分页器
        handleYetBindProjectPageChange(val) {
            this.$set(this.yetBindProjectQuery, 'pageIndex', val);
            this.queryProjectData();
        },

        // 查看用户分页器
        handleYetBindUserPageChange(val) {
            this.$set(this.yetBindUserQuery, 'pageIndex', val);
            this.queryUserData();
        },

        // 确认绑定项目
        async handleProjectBindCompany(index, row) {
            // 二次绑定确认
            this.$confirm('确认绑定该项目吗?', '提示', {
                type: 'warning'
            })
                .then(async () => {
                    const result = await CompanyProject({ companyId: this.queryBindProjectId, projectId: row.projectId });
                    if (result.code !== 200) {
                        return;
                    }
                    this.$message.success('绑定成功');
                    this.queryBindProject();
                })
                .catch(() => { });
        },
        // 绑定项目
        async bindProject(index, row) {
            this.queryBindProjectId = row.id;
            // 查询该企业未绑定的用户
            this.bindProjectVisible = true;
            this.queryBindProject();
        },
        // 查询企业未绑定的项目
        async queryBindProject() {
            const result = await QueryUnbindProject({
                companyId: this.queryBindProjectId,
                limit: this.bindProjectQuery.pageSize,
                offset: this.bindProjectQuery.pageIndex - 1
            });
            if (result.code !== 200) {
                return;
            }

            this.bindProjectPageTotal = result.data.count;
            this.bindProjectTableData = result.data.rows;

            console.log(result);
            console.log(this.bindProjectTableData);
        },
        // 关闭绑定项目弹窗前
        handleBindProjectDialogClose() {
            this.bindProjectQuery = {
                pageIndex: 1,
                pageSize: 10
            };
            this.bindProjectVisible = false;
        },
        // 关闭查看用户弹窗前
        handleYetBindUserDialogClose() {
            this.yetBindUserQuery = {
                pageIndex: 1,
                pageSize: 10
            };
            this.userVisible = false;
        },
        // 关闭查看项目弹窗前
        handleYetBindProjectDialogClose() {
            this.yetBindProjectQuery = {
                pageIndex: 1,
                pageSize: 10
            };
            this.projectVisible = false;
        },

        // 确认绑定用户
        async handleUserBindCompany(index, row) {
            // 二次绑定确认
            this.$confirm('确认绑定该用户吗?', '提示', {
                type: 'warning'
            })
                .then(async () => {
                    const result = await CompanyUser({ companyId: this.queryBindUserId, userId: row.id });
                    if (result.code !== 200) {
                        return;
                    }
                    this.$message.success('绑定成功');
                    this.queryBindUser();
                })
                .catch(() => { });
        },
        // 关闭绑定用户弹窗前
        handleBindUserDialogClose() {
            this.bindUserQuery = {
                pageIndex: 1,
                pageSize: 10
            };
            this.userQueryBox = {
                label: '姓名',
                value: ''
            };
            this.bindUserVisible = false;
            this.userPaginationShow = true;
        },
        // 绑定用户
        async bindUser(index, row) {
            this.queryBindUserId = row.id;
            // 查询该企业未绑定的用户
            this.bindUserVisible = true;
            this.queryBindUser();
        },
        // 查询企业未绑定的用户
        async queryBindUser() {
            const result = await QueryUnbindUser({
                companyId: this.queryBindUserId,
                limit: this.bindUserQuery.pageSize,
                offset: this.bindUserQuery.pageIndex - 1
            });
            if (result.code !== 200) {
                return;
            }
            this.bindUserPageTotal = result.data.count;
            this.bindUserTableData = result.data.rows;

            this.bindUserTableData.forEach((item, index) => {
                this.bindUserTableData[index].createDate = moment(item.createTime * 1).format('YYYY-MM-DD HH:mm:ss');
            });
            console.log(result);
        },
        // 删除企业
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确认删除该企业吗?', '提示', {
                type: 'warning'
            })
                .then(async () => {
                    // 确认删除企业
                    const result = await DeleteCompany({ companyId: row.id });
                    if (result.code !== 200) {
                        return;
                    }
                    this.$message.success('删除成功');
                    this.getData();
                })
                .catch(() => { });
        },
        // 查看项目打开弹窗
        async queryProject(index, row) {
            this.clickCompanyId = row.id;
            this.queryProjectData();
            this.projectVisible = true;
        },
        // 查看项目
        async queryProjectData() {
            const result = await QueryCompanyProject({
                companyId: this.clickCompanyId,
                limit: this.yetBindProjectQuery.pageSize,
                offset: this.yetBindProjectQuery.pageIndex - 1
            });
            console.log(result);
            if (result.code !== 200) {
                return;
            }
            this.yetVindProjectPageTotal = result.data.count;

            let projectArr = [];
            result.data.rows.forEach((item) => {
                projectArr.push({
                    projectId: item.projectId,
                    bindTime: item.createTime
                });
            });
            // 根据查询的项目id查找项目信息
            for (let i = 0; i < projectArr.length; i++) {
                const projectResult = await QueryProjectName({ projectId: projectArr[i].projectId });
                console.log(projectResult);

                projectArr[i].name = projectResult.data.projectName;
                projectArr[i].projectCreateTime = projectResult.data.createTime;
            }
            projectArr.forEach((item, index) => {
                projectArr[index].bindDate = moment(item.bindTime * 1).format('YYYY-MM-DD HH:mm:ss');
            });
            console.log(projectArr);
            this.projectTableData = projectArr;
            this.projectVisible = true;
        },

        // 查看用户打开弹窗
        async queryUser(index, row) {
            this.clickCompanyId = row.id;
            this.queryUserData();
            this.userVisible = true;
        },
        // 获取企业已经绑定的用户
        async queryUserData() {
            const result = await QueryUserCompany({
                companyId: this.clickCompanyId,
                limit: this.yetBindUserQuery.pageSize,
                offset: this.yetBindUserQuery.pageIndex - 1
            });
            console.log(result);
            if (result.code !== 200) {
                return;
            }

            this.yetVindUserPageTotal = result.data.count;
            let userArr = [];
            result.data.rows.forEach((item) => {
                userArr.push({
                    userId: item.userId,
                    bindTime: item.createTime
                });
            });
            // 根据查询的用户查找用户信息
            for (let i = 0; i < userArr.length; i++) {
                const userResult = await QueryUser({ userId: userArr[i].userId });
                userArr[i].name = userResult.data.name;
                userArr[i].phone = userResult.data.phone;
                userArr[i].userCreateTime = userResult.data.createTime;
            }
            userArr.forEach((item, index) => {
                userArr[index].bindDate = moment(item.bindTime * 1).format('YYYY-MM-DD HH:mm:ss');
                userArr[index].userCreateDate = moment(item.userCreateTime * 1).format('YYYY-MM-DD HH:mm:ss');
            });
            console.log(userArr);
            this.userTableData = userArr;
        },

        // 增加企业
        async addCompany() {
            this.$prompt('请输入企业名称', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            })
                .then(async ({ value }) => {
                    console.log(value);

                    if (value.trim() == '') {
                        this.$message.warning('请输入正确的名称');
                        return;
                    }
                    let result = await AddCompany({ name: value.trim(), role: '1' });
                    if (result.code !== 200) {
                        return;
                    }
                    this.$message.success('创建成功');
                    this.getData();
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
        },

        async getData() {
            let searchTag = this.query.searchTag.trim();
            let searchValue = this.query.searchValue.trim();
            const { data } = await AllCompany({
                searchTag,
                searchValue: searchValue ? searchValue : '%',
                limit: this.query.pageSize,
                offset: this.query.pageIndex - 1
            });
            this.pageTotal = data.count;
            let dataArr = [];
            data.rows.forEach((item) => {
                let obj = item;
                item.createtime = moment(item.createTime * 1).format('YYYY-MM-DD HH:mm:ss');

                item.updatetime = moment(item.updateTime * 1).format('YYYY-MM-DD HH:mm:ss');
                dataArr.push(obj);
            });
            this.tableData = dataArr;
        },

        // 触发搜索按钮
        async handleSearch() {
            // 判断搜索框输入是否正常
            let searchTag = this.query.searchTag.trim();
            let searchValue = this.query.searchValue.trim();
            if (searchTag == '' || searchValue == '') {
                this.$message.warning('请检查输入');
                return;
            }

            // 开始搜索
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 重置搜索企业
        handleResetSearch() {
            this.query.searchValue = '';
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
            }
            this.$message.error(`删除了${str}`);
            this.multipleSelection = [];
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.form = row;
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        // 绑定用户查询表格分页
        handleBindUserPageChange(val) {
            this.$set(this.bindUserQuery, 'pageIndex', val);
            this.queryBindUser();
        }
    },
    components: {
        mscard
    }
};
</script>

<style scoped lang="less">
@import '../../assets/css/variables.less';

.container {
    background-color: @black-two;
}

// 修改弹窗样式 ---开始--
/deep/ .el-dialog__header {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-dialog__title {
    color: #fff;
}

/deep/ .el-dialog__body {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-dialog__footer {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-table th {
    background-color: @black-two !important;
    color: @gray-one;
}

/deep/ .el-table tr {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-table tr:hover {
    background: @black-three !important;
}

/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background: none;
}

/deep/ .el-table__empty-block {
    background-color: @black-two;

    border: none;
}

/deep/ .el-table__empty-text {
    color: #fff;
}

/deep/ .el-button--text {
    color: @gray-one;
}

/deep/ .el-button--text:hover {
    color: #fff;
}

/deep/ .el-button--primary {
    background-color: @black-three;
    color: #fff;
    border: none;
    transition: all 0.5s;
}

/deep/ .el-button--primary:hover {
    background-color: #fff;
    color: @black-three;
    border: none;
}

/deep/ .el-dialog__headerbtn .el-dialog__close:hover {
    color: #fff;
}

/deep/ .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    border: none !important;
}

// 修改弹窗样式 ---结束--

.handle-box {
    margin-bottom: 20px;
    margin-top: -20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.userSearchBox {
    margin-top: -20px;
    margin-bottom: 10px;
}
</style>
